import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-secondary-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className={`ri-book-read-line text-xl ${scrolled || !isHome ? 'text-primary-500' : 'text-background-50'}`}></i>
            </div>
            <span className={`font-heading text-xl font-bold ${scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'}`}>
              韩漫网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/' ? (scrolled || !isHome ? 'text-primary-500' : 'text-accent-300') : (scrolled || !isHome ? 'text-foreground-600 hover:text-primary-500' : 'text-background-50/80 hover:text-background-50')
              }`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className={`flex items-center gap-1 text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname.startsWith('/category') ? (scrolled || !isHome ? 'text-primary-500' : 'text-accent-300') : (scrolled || !isHome ? 'text-foreground-600 hover:text-primary-500' : 'text-background-50/80 hover:text-background-50')
                }`}
              >
                分类
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className={`ri-arrow-down-s-line text-xs transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
                </div>
              </button>
              {categoryOpen && (
                <div className="absolute top-full left-0 mt-2 w-48 bg-background-50 rounded-lg border border-secondary-200/70 py-2">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-600 hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap"
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className={`${cat.icon} text-sm`}></i>
                      </div>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about' ? (scrolled || !isHome ? 'text-primary-500' : 'text-accent-300') : (scrolled || !isHome ? 'text-foreground-600 hover:text-primary-500' : 'text-background-50/80 hover:text-background-50')
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 hover:bg-secondary-200 transition-colors cursor-pointer">
              <i className={`ri-search-line text-sm ${scrolled || !isHome ? 'text-foreground-600' : 'text-background-50'}`}></i>
            </button>
            <button className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
              scrolled || !isHome ? 'bg-primary-500 text-background-50 hover:bg-primary-600' : 'bg-background-50/20 text-background-50 hover:bg-background-50/30 backdrop-blur-sm'
            }`}>
              开始阅读
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} ${scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-secondary-200/70 px-4 py-4">
          <div className="flex flex-col gap-2">
            <Link to="/" className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50 transition-colors whitespace-nowrap">首页</Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-3 px-3 py-2.5 text-sm text-foreground-600 hover:text-primary-500 rounded-lg hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-sm`}></i>
                </div>
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50 transition-colors whitespace-nowrap">关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}